import { render, staticRenderFns } from "./image3D.vue?vue&type=template&id=67e8b0fa&scoped=true"
import script from "./image3D.vue?vue&type=script&lang=js"
export * from "./image3D.vue?vue&type=script&lang=js"
import style0 from "./image3D.vue?vue&type=style&index=0&id=67e8b0fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e8b0fa",
  null
  
)

export default component.exports